//If you need to store something that can survive page refresh and window closing
class PersistentDataStoreProvider {
  set(key, value) {
    localStorage.setItem(key, value);
  }

  get(key) {
    return localStorage.getItem(key);
  }

  remove(key) {
    localStorage.removeItem(key);
  }
}

export default PersistentDataStoreProvider;
